var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_2497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.45 20.61C16.9567 20.61 20.61 16.9566 20.61 12.45C20.61 7.94333 16.9567 4.28998 12.45 4.28998C7.94336 4.28998 4.29001 7.94333 4.29001 12.45C4.29001 16.9566 7.94336 20.61 12.45 20.61Z",
    stroke: "#414042",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.28 10.13C11.28 8.30998 11.97 6.64998 13.11 5.38998C12.87 5.36998 12.63 5.34998 12.39 5.34998C8.48 5.34998 5.31 8.51998 5.31 12.43C5.31 16.34 8.48 19.51 12.39 19.51C14.48 19.51 16.35 18.6 17.65 17.16C14.08 16.8 11.29 13.78 11.29 10.11L11.28 10.13Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.68 1H12.21V2.47H12.68V1Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.68 22.42H12.21V23.89H12.68V22.42Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.89 12.68V12.21H22.42V12.68H23.89Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47 12.68V12.21H1V12.68H2.47Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3681 20.7059L20.7005 20.3735L19.661 19.3341L19.3287 19.6664L20.3681 20.7059Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22348 5.55591L5.55582 5.22357L4.51637 4.18412L4.18403 4.51647L5.22348 5.55591Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18676 20.3708L4.5191 20.7031L5.55855 19.6637L5.22621 19.3313L4.18676 20.3708Z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3314 5.22082L19.6638 5.55316L20.7032 4.51371L20.3709 4.18137L19.3314 5.22082Z",
    fill: "#414042"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_2497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.89,
    height: 22.89,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark_mode.4c82fff7e731dd5b368f2dd30931e14b.svg";
export { ForwardRef as ReactComponent };